import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const Leftnav = () => {
  const [categories, setcategories] = useState([]);
  useEffect(() => {
    fetch("http://localhost:5000/tutorial-category")
      .then((res) => res.json())
      .then((data) => setcategories(data));
  }, []);
  return (
    <div className="">
      {/* <h1 className="text-3xl font-bold p-2">All category</h1> */}
      <div>
        {categories.map((category) => (
          <p 
          className="p-2 m-3 text-xl text-black bg-blue-600 rounded-md hover:bg-purple-700"
          key={category.id}>
            <Link to={`/categories/${category.id}`}>{category.name}</Link>
          </p>
        ))}
      </div>
    </div>
  );
};

export default Leftnav;
